<div class="notifi_msg">
  {{data.msg}}
</div>
